import { memo } from "react";
import { Circle, ShieldAlert, X } from "lucide-react";

interface RecordingConsentModalProps {
  isOpen: boolean;
  otherUserName: string;
  onAccept: () => void;
  onDecline: () => void;
}

const RecordingConsentModal = memo(({
  isOpen,
  otherUserName,
  onAccept,
  onDecline,
}: RecordingConsentModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="relative w-full max-w-sm bg-card rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        {/* Close button */}
        <button
          onClick={onDecline}
          className="absolute top-3 right-3 p-1.5 rounded-full bg-muted hover:bg-muted/80 transition-colors z-10"
        >
          <X className="w-4 h-4 text-muted-foreground" />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-br from-red-500 to-red-600 p-6 text-center">
          <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-white/20 flex items-center justify-center">
            <Circle className="w-8 h-8 text-white fill-white animate-pulse" />
          </div>
          <h2 className="text-xl font-bold text-white">Recording Request</h2>
        </div>

        {/* Content */}
        <div className="p-5">
          <div className="flex items-start gap-3 mb-4 p-3 rounded-lg bg-yellow-500/10 border border-yellow-500/20">
            <ShieldAlert className="w-5 h-5 text-yellow-500 shrink-0 mt-0.5" />
            <p className="text-sm text-foreground/80">
              <span className="font-semibold">{otherUserName}</span> wants to record this video call. 
              Both video and audio will be captured.
            </p>
          </div>

          <p className="text-sm text-muted-foreground text-center mb-5">
            By accepting, you consent to being recorded. The recording will be saved locally.
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onDecline}
              className="flex-1 py-3 px-4 rounded-xl font-medium bg-muted hover:bg-muted/80 text-foreground transition-colors"
            >
              Decline
            </button>
            <button
              onClick={onAccept}
              className="flex-1 py-3 px-4 rounded-xl font-medium bg-red-500 hover:bg-red-600 text-white transition-colors"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
});

RecordingConsentModal.displayName = "RecordingConsentModal";

export default RecordingConsentModal;
